export default __webpack_public_path__ + "static/media/BAE.2acb9cff.png";